import { useState, useEffect } from 'react'
import { useMutation } from '@tanstack/react-query'
import { useAuthStore } from '@/stores/auth'
import { api } from '@/lib/api'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { toast } from '@/components/ui/toaster'

export function SettingsPage() {
  const { user, fetchUser } = useAuthStore()
  const [username, setUsername] = useState(user?.username || '')

  // Fetch user on mount
  useEffect(() => {
    fetchUser()
  }, [fetchUser])

  // Update username state when user data loads
  useEffect(() => {
    if (user?.username) {
      setUsername(user.username)
    }
  }, [user?.username])

  const updateMutation = useMutation({
    mutationFn: () => api.updateProfile(username),
    onSuccess: () => {
      fetchUser()
      toast({ title: 'Profile updated' })
    },
    onError: () => {
      toast({ title: 'Update failed', variant: 'destructive' })
    },
  })

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      {/* Profile Settings */}
      <div className="bg-white rounded-xl border border-gray-200/60 shadow-sm p-6">
        <h2 className="text-lg font-semibold mb-4">Profile</h2>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <Input value={user?.email || ''} disabled className="bg-gray-50" />
            <p className="text-xs text-gray-500 mt-1">Email cannot be changed</p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Username</label>
            <Input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
            />
          </div>

          <Button
            onClick={() => updateMutation.mutate()}
            disabled={updateMutation.isPending || username === user?.username}
          >
            {updateMutation.isPending ? 'Saving...' : 'Save Changes'}
          </Button>
        </div>
      </div>

      {/* Global Rules */}
      <div className="bg-white rounded-xl border border-gray-200/60 shadow-sm p-6">
        <h2 className="text-lg font-semibold mb-4">Global Generation Rules</h2>
        <p className="text-sm text-gray-600 mb-4">
          These rules will be applied to all your generations as the system prompt layer.
        </p>

        <textarea
          className="w-full border rounded-md p-3 h-32"
          defaultValue={user?.global_rule ? JSON.stringify(user.global_rule, null, 2) : ''}
        />

        <Button className="mt-4" variant="outline">
          Update Rules
        </Button>
      </div>

    </div>
  )
}
